import $ from 'jquery';

const accordion = (() => {
  const defaultAccordion = () => {
    const accordionItem = document.getElementsByClassName('js-trigger-accordion');

    for (let i = 0; i < accordionItem.length; i += 1) {
      accordionItem[i].addEventListener('click', function (event) {
        event.currentTarget.classList.toggle('js-active');
        const accordionContent = this.nextElementSibling;
        event.currentTarget.querySelector('.c-accordion__icon svg').classList.toggle('js-active');
        accordionContent.classList.toggle('js-active');
      });
    }
  };

  const arrowDownBtn = () => {
    $(".suit-description .more").on("click", function(){
      $('body,html').animate({ scrollTop: $(".page-detail").offset().top }, 800);
    });
  };

  const homeReservationScroll = () => {
    var floatingDiv = document.getElementById('hr_search_widget');
    var floatingDivParent = document.querySelector(".home-revervation-bar");
    if (floatingDivParent) {
      var scrollPosition = window.scrollY || document.documentElement.scrollTop;
      var scrollFirstPosition = floatingDivParent.offsetTop + floatingDiv.offsetTop - 20;
      var scrolldDataPos = floatingDivParent.setAttribute('data-offset-top', scrollFirstPosition);
      var scrollDataPosAt = floatingDivParent.getAttribute('data-offset-top');
      if (scrollPosition >= scrollDataPosAt) { 
        floatingDivParent.classList.add('fixed');
      } else { 
        floatingDivParent.classList.remove('fixed');
      }

      $(window).scroll(function() {
        var scrollPosition = window.scrollY || document.documentElement.scrollTop;
        if (scrollPosition >= scrollDataPosAt) { 
          floatingDivParent.classList.add('fixed');
        } else { 
          floatingDivParent.classList.remove('fixed');
        }
      });
    } 
  };

  const detailReservationScroll = () => {
    var floatingDivR = document.getElementsByClassName('detail_hr_search');
    var floatingDivParentR = document.querySelector(".detail-revervation-bar");
    if (floatingDivParentR) {
      var scrollPositionR = window.scrollY || document.documentElement.scrollTop;
      var scrollFirstPositionR = floatingDivParentR.offsetTop;
      var scrolldDataPosR = floatingDivParentR.setAttribute('data-offset-top', scrollFirstPositionR);
      var scrollDataPosAtR = floatingDivParentR.getAttribute('data-offset-top');
      if (scrollPositionR >= scrollDataPosAtR) { 
        floatingDivParentR.classList.add('fixed');
      } else { 
        floatingDivParentR.classList.remove('fixed');
      }

      $(window).scroll(function() {
        var scrollPositionR = window.scrollY || document.documentElement.scrollTop;
        if (scrollPositionR >= scrollDataPosAtR) { 
          floatingDivParentR.classList.add('fixed');
        } else { 
          floatingDivParentR.classList.remove('fixed');
        }
      });
    } 
  };

  const init = () => {
    defaultAccordion();
    arrowDownBtn();
    homeReservationScroll();
    detailReservationScroll();
  };

  return {
    init,
  };
})();

export default accordion;
